import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Table } from '@buildoutinc/blueprint-react/ui/Table';
import { sortIcons } from 'helpers/icon_helpers';

import type { ColumnConfig, SortState } from './types';

interface Props {
  columnConfig: ColumnConfig;
  sortState: SortState;
  onSort: (sortKey: string, direction: 'asc' | 'desc') => void;
}

export default function ColumnHeader({ columnConfig, sortState, onSort }: Props) {
  const sortable = !!columnConfig.sortKey;
  const active = sortable && sortState.name === columnConfig.sortKey;

  const handleSort = () => {
    if (!columnConfig.sortKey) return;

    const newDirection = active && sortState.direction === 'asc' ? 'desc' : 'asc';
    onSort(columnConfig.sortKey, newDirection);
  };

  let icon = sortIcons.sort;
  if (active) {
    icon = sortState.direction === 'asc' ? sortIcons.alpha.asc : sortIcons.alpha.desc;
  }

  // tabIndex and the key handler keep sorting reachable without a mouse, since a th cannot be a button.
  return (
    <Table.Head
      aria-sort={active ? (sortState.direction === 'asc' ? 'ascending' : 'descending') : undefined}
      className={sortable ? 'clickable text-nowrap' : 'text-nowrap'}
      tabIndex={sortable ? 0 : undefined}
      onClick={handleSort}
      onKeyDown={(event: React.KeyboardEvent<HTMLTableCellElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleSort();
        }
      }}
    >
      {columnConfig.label}
      {sortable && <FontAwesomeIcon className="ms-1" icon={icon} />}
    </Table.Head>
  );
}
